import React from 'react';
import { useMediaQuery } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  mainTitle: {
    fontFamily : "'Zen Dots', sans-serif",
    fontSize: '3.5rem',
    lineHeight: '4rem',
    color: '#ffffff'
  },
  primaryCard: {
    width: '32rem',
    margin: '.3rem',
    boxShadow: 'none',
    background: 'transparent'
  },
  secondaryCard: {
    width: '200px',
    margin: '.3rem',
    boxShadow: 'none',
    textAlign: 'center',
    borderRight: '1px #ddd solid',
    '&:last-child': {
      borderRight: 'none'
    },
    background: 'transparent'
  },
  secondaryCardTitle: {
    color: '#FFC840',
    fontFamily : "'Zen Dots', sans-serif",
  },
  chevron: {
    fill: '#ffffff',
    width: '48px',
    height: 'auto',
  },
  illustration: {
    width: '250px',
    height: 'fit-content'
  }
}));

export default function HomePageSectionOne() {
  const classes = useStyles();

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={6} container>
        <Grid container item justifyContent="center" xs={12}>
          <Card className={(classes.secondaryCard, classes.primaryCard)}>
            <CardContent>
              <Typography variant="h3" component="h2" className={classes.mainTitle}>
                Build your Bot in Seconds
              </Typography>
              <Typography paragraph={true}>
                Streamline work and automate workflows with bots and apps.
              </Typography>
              <Typography>
                Build integrations from a simple 'hello world' example to fully fledged financial integrations on Symphony!
              </Typography>
              <List>
                <ListItem>
                  <ListItemIcon>
                    <ChevronRightIcon className={classes.chevron} />
                  </ListItemIcon>
                  <ListItemText
                    primary="Innovate time-saving bots and apps that exist entirely in chat rooms."
                  />
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <ChevronRightIcon className={classes.chevron} />
                  </ListItemIcon>
                  <ListItemText
                    primary="Help some of the largest companies in the world plan their automation strategies."
                  />
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <ChevronRightIcon className={classes.chevron} />
                  </ListItemIcon>
                  <ListItemText
                    primary="Use our extensible platform to bring your favorite third-party apps onto Symphony."
                  />
                </ListItem>
              </List>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <Grid item xs={12} md={6} container>
        <Grid container item justifyContent="center" xs={12}>
          <Card className={classes.secondaryCard}>
            <CardContent>
              <Typography variant="h5" component="h2" className={classes.secondaryCardTitle}>
                2,500+
              </Typography>
              <Typography>
                Active Bots on the Symphony Platform
              </Typography>
            </CardContent>
          </Card>
          <Card className={classes.secondaryCard}>
            <CardContent>
              <Typography variant="h5" component="h2" className={classes.secondaryCardTitle}>
                18+ Million
              </Typography>
              <Typography>
                Messages sent by bots monthly
              </Typography>
            </CardContent>
          </Card>
          <Card className={classes.secondaryCard}>
            <CardContent>
              <Typography variant="h5" component="h2" className={classes.secondaryCardTitle}>
                2000+
              </Typography>
              <Typography>
                Registered Developers in the Symphony Developer Center
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid container item justifyContent="center" xs={12}>
          <img src="/sym-mascot-illo-wave.png" className={classes.illustration} alt="Mascot" />
        </Grid>
      </Grid>
    </Grid>
  );
}
